var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83325 0.5C3.96925 0.5 0.833252 3.636 0.833252 7.5C0.833252 11.364 3.96925 14.5 7.83325 14.5C11.6973 14.5 14.8333 11.364 14.8333 7.5C14.8333 3.636 11.6973 0.5 7.83325 0.5ZM11.2633 9.943L10.2833 10.923C10.1433 11.063 9.92625 11.063 9.78625 10.923L7.39925 8.536C6.54525 8.837 5.55125 8.655 4.86525 7.969C4.08825 7.192 3.95525 6.016 4.45225 5.099L6.09725 6.744L7.08425 5.757L5.43925 4.119C6.36325 3.622 7.53225 3.755 8.30925 4.532C8.99525 5.218 9.17725 6.212 8.87625 7.066L11.2633 9.453C11.3963 9.586 11.3963 9.81 11.2633 9.943Z",
    fill: "#6E6E6E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduction);
export default __webpack_public_path__ + "static/media/production.5c61f3c2ca5c43c2c31a3a9e98f4daf4.svg";
export { ForwardRef as ReactComponent };